module.exports = __webpack_public_path__ + "img/Talk.13628bfa.svg";